import axiosInstance from './axiosInstance';

const getIndexers = () => axiosInstance.get('/internal/admin/config/indexers');

export default getIndexers;
